import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { OfferLink } from './OfferLink';
import { product, systemIntro } from '../data/salesCopy';
export function SystemIntro() {
  return <section className="bg-brand-sage px-4 py-8 text-brand-ivory sm:py-10" data-id="element-245" data-mp="23957zoachwgw">
      <div className="mx-auto max-w-4xl" data-id="element-246" data-mp="23b814h6so5pu">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-gold sm:text-xs" data-id="element-247" data-mp="286x1unujvsnq">
          {systemIntro.eyebrow}
        </p>
        <h2 className="mt-2 text-center font-serif text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-248" data-mp="1fjb07l4vuy3i">
          {systemIntro.heading}
        </h2>

        <div className="mt-5 grid items-center gap-5 sm:grid-cols-[auto_1fr] sm:gap-7" data-id="element-249" data-mp="1kh2pe7e58640">
          <OfferLink className="block" data-id="element-250" data-mp="1pj1vvq56jj56">
            <img src={product.image} alt="YIN YOGA READY™ box set with six modules" className="mx-auto w-full max-w-[210px] drop-shadow-2xl transition-transform duration-200 ease-smooth hover:scale-[1.02]" data-id="element-251" data-mp="2vxj9ie0n7ax7" />
          </OfferLink>

          <div className="text-center sm:text-left" data-id="element-252" data-mp="15gb197wlrmyc">
            <p className="font-serif text-2xl font-extrabold uppercase leading-none text-white sm:text-3xl" data-id="element-253" data-mp="11i3m2hhsetp9">
              🧘 {product.name}
            </p>
            <p className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.18em] text-brand-sand sm:text-xs" data-id="element-254" data-mp="riuutweb3t6l">
              {product.tagline}
            </p>
            <p className="mt-1.5 text-[11px] font-semibold text-brand-ivory/80 sm:text-xs" data-id="element-255" data-mp="mlcgtrlfmnrq">
              {product.strip}
            </p>

            <ul className="mt-3 space-y-1" data-id="element-256" data-mp="drhdmp3vf7eq">
              {systemIntro.nots.map(line => <li key={line} className="flex items-start justify-center gap-1.5 text-[12.5px] font-medium leading-snug text-brand-ivory/80 sm:justify-start sm:text-[13.5px]" data-id="element-257" data-mp="8sd4tzkuzbox">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-clay" aria-hidden="true" data-id="element-258" data-mp="3uzbdkvg8ad6a" />
                  {line}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-5 rounded-lg border border-brand-gold/40 bg-brand-sageDark/60 p-4 text-center" data-id="element-259" data-mp="3cbamiijjl4p2">
          <p className="text-[12.5px] font-semibold text-brand-ivory/85 sm:text-sm" data-id="element-260" data-mp="3gcmf8wxpq61h">
            {systemIntro.bridge}
          </p>
          <p className="mt-1.5 font-serif text-base italic text-brand-clay sm:text-lg" data-id="element-261" data-mp="7y42wj0qo4c2">
            {systemIntro.from}
          </p>
          <p className="text-[11px] font-bold uppercase tracking-widest text-brand-ivory/60" data-id="element-262" data-mp="cve2grhudwdm">
            to
          </p>
          <p className="font-serif text-base font-extrabold text-brand-gold sm:text-xl" data-id="element-263" data-mp="36cloz3h3ayl">
            {systemIntro.to}
          </p>
        </div>

        <ul className="mt-5 grid gap-x-5 gap-y-1.5 sm:grid-cols-2" data-id="element-264" data-mp="quvqh4nbd5lx">
          {systemIntro.checks.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-semibold leading-snug text-white sm:text-[13.5px]" data-id="element-265" data-mp="vo83ehimrnyu">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-266" data-mp="2bcxypaw8y0f2" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}